import FinishedScreen from './FinishedScreen';
import { selectAutoCloseConfiguration } from '../../app/slices/configuration.slice';
import { useContext, useEffect } from 'react';
import { AutoCloseContext } from '../AutoCloseContext';
import Timeoutable from './Timeoutable';
import NextButton from '../NextButton';
import { useTranslation } from 'react-i18next';
import { FINISHED_STEP_PREFIX } from '../../utils/translationPagePrefix';
import { useAppSelector } from '../../app/hooks';
import { sdkCallbacks } from '../../features/session/sdk-callbacks';
import { reportError } from '../../app/slices/error.slice';

const FinishedStep = () => {
	const { autoClose, autoCloseSeconds } = useAppSelector(selectAutoCloseConfiguration);
	const { close } = useContext(AutoCloseContext);

	const { t } = useTranslation();

	useEffect(() => {
		sdkCallbacks.execute('onFinished').catch((error) => reportError({ type: 'TECHNICAL', reason: error }));
	}, []);

	const title = t(`${FINISHED_STEP_PREFIX}.title`);
	const buttonText = t(`${FINISHED_STEP_PREFIX}.continue`);

	if (autoClose) {
		const subtitle = t(`${FINISHED_STEP_PREFIX}.subtitle`);

		return (
			<Timeoutable timeout={autoCloseSeconds * 1000} onTimeout={close}>
				<FinishedScreen title={title} subtitle={subtitle} />
			</Timeoutable>
		);
	}

	const subtitle = t(`${FINISHED_STEP_PREFIX}.banking-process`);
	return (
		<FinishedScreen title={title} subtitle={subtitle}>
			<NextButton text={buttonText} onClick={close} />
		</FinishedScreen>
	);
};

export default FinishedStep;
